import React from "react";
import HomeOverlay from "./components/HomeOverlay";
import HomeHeader from "./components/HomeHeader";

const HomeUI = ({
    mapRef, ZSTPopUpContent, setMapParameters, setZSTPopUpContent, startDate, fetchCommonDates, setStartDate, tscCoords, tscModeRef, setEnabledDates, isButtonClicked, setIsButtonClicked, layerRefs, setIsDatePickerDisabled, isDatePickerDisabled
}) => {

    return (
        <>
            <HomeOverlay
                mapRef={mapRef}
                layerRefs={layerRefs}
                isDatePickerDisabled={isDatePickerDisabled}
                setIsDatePickerDisabled={setIsDatePickerDisabled}
                ZSTPopUpContent={ZSTPopUpContent}
                setEnabledDates={setEnabledDates}
                setZSTPopUpContent={setZSTPopUpContent}
                startDate={startDate}
                setMapParameters={setMapParameters}
                setStartDate={setStartDate}
                fetchCommonDates={fetchCommonDates}
                tscCoords={tscCoords}
                tscModeRef={tscModeRef}
                isButtonClicked={isButtonClicked}
                setIsButtonClicked={setIsButtonClicked}
            />

            <HomeHeader />
        </>
    );
}

export default HomeUI;